import { name } from './constants';
import reducer from './reducer';
import Paytickets from './Paytickets';

export default {
  name,
  Paytickets,
  reducer,
};



// WEBPACK FOOTER //
// ./src/sites/payTickets/index.js